import {
  create_order_record,
  query_order_record_normal_list,
  direct_delete_order_record,
} from '@/api/mjstore-model';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import {
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/components/page-model/mjstore/mjstore-orderrecord-config';
import column_config from '@/components/page-model/mjstore/mjstore-orderrecord-column-config';

import { reactive } from 'vue';

export default () => {
  const None = null;
  const True = true;
  const False = false;

  const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
  const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店
  const { baseColumns, newSlotList } = column_config(current_org);

  const search_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'inline',
    },
    fields: [
      {
        type: 'input',
        name: 'order_code',
        label: '订单号',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        defaultValue: '',
        placeholder: '请填写下单号',
      },
      {
        type: 'remotemodal',
        name: 'project_id',
        label: '项目名称',
        disabled: false,
        placeholder: '请选择项目名称',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-project',
      },
      {
        type: 'remotemodal',
        name: 'customer_id',
        label: '会员姓名',
        disabled: false,
        placeholder: '请选择会员姓名',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-customer',
      },
      {
        type: 'remotemodal',
        name: 'staff_id',
        label: '执行人',
        disabled: false,
        placeholder: '请选择执行人',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        init_model: { shop_id: current_shop?.id },
        modalType: 'mjstore-staff',
      },
      {
        type: 'remoteselect',
        name: 'cxzc_id',
        label: '促销政策',
        disabled: false,
        placeholder: '请选择促销政策',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-policy',
      },
      // {
      //   type: 'remoteselect',
      //   name: 'shop_id',
      //   label: '执行门店',
      //   disabled: false,
      //   placeholder: '请选择执行门店',
      //   datasourceType: 'remote',
      //   mode: 'default',
      //   allowClear: true,
      //   modalType: 'mjstore-shop',
      // },
      {
        type: 'rangepicker',
        name: 'date_interval',
        label: '下单日期',
        disabled: false,
        allowClear: true,
        inputType: 'number',
        defaultValue: '',
        format: 'YYYY-MM-DD',
        valueFormat: 'YYYY-MM-DD',
        showTime: false,
        placeholder: '请选择下单日期',
      },
      {
        type: 'select',
        name: 'is_now_num',
        label: '执行情况',
        disabled: false,
        placeholder: '请选择执行情况',
        mode: 'default',
        allowClear: true,
      },
    ],
    rules: {},
    model: reactive({
      org_id: current_org?.id,
      is_active: true,
      order_code: null,
      project_id: null,
      customer_id: null,
      staff_id: null,
      card_id: null,
      card_record_id: null,
      cxzc_id: null,
      shop_id: current_shop?.id,
      is_now_num: true,
      is_delete: false,
      delete_staff_id: null,
    }),
  };
  const search_options = {
    is_delete: [
      { value: None, name: '全部' },
      { value: True, name: '已撤单' },
      { value: False, name: '未撤单' },
    ],
    is_now_num: [
      { value: true, label: '待执行' },
      { value: false, label: '执行完' },
    ],
  };

  const edit_model_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'horizontal',
      col: config.creatCol,
    },
    fields: [
      {
        type: 'remotemodal',
        name: 'customer_id',
        label: '会员姓名',
        disabled: false,
        placeholder: '请选择会员姓名',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-customer',
      },
      {
        type: 'remotemodal',
        name: 'project_id',
        label: '项目名称',
        disabled: false,
        placeholder: '请选择项目名称',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-project',
      },
      {
        type: 'input',
        name: 'total_num',
        label: '项目次数',
        disabled: false,
        allowClear: true,
        inputType: 'number',
        defaultValue: '',
        placeholder: '请填写购买单数',
      },
      {
        type: 'input',
        name: 'order_code',
        label: '下单号',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        defaultValue: '',
        placeholder: '请填写下单号',
      },
      {
        type: 'input',
        name: 'price',
        label: '总价',
        disabled: false,
        allowClear: true,
        inputType: 'number',
        defaultValue: '',
        placeholder: '请填写总价',
      },
      {
        type: 'input',
        name: 'czje',
        label: '充值使用金额',
        disabled: false,
        allowClear: true,
        inputType: 'number',
        defaultValue: '',
        placeholder: '请填写充值使用金额',
      },
      {
        type: 'input',
        name: 'flje',
        label: '返利使用金额',
        disabled: false,
        allowClear: true,
        inputType: 'number',
        defaultValue: '',
        placeholder: '请填写返利使用金额',
      },
      {
        type: 'input',
        name: 'zjfl',
        label: '直接返利',
        disabled: false,
        allowClear: true,
        inputType: 'number',
        defaultValue: '',
        placeholder: '请填写直接返利',
      },
      {
        type: 'input',
        name: 'zjje',
        label: '赠券使用金额',
        disabled: false,
        allowClear: true,
        inputType: 'number',
        defaultValue: '',
        placeholder: '请填写赠券使用金额',
      },
      {
        type: 'datepicker',
        name: 'date',
        label: '下单日期',
        disabled: false,
        allowClear: true,
        inputType: 'number',
        defaultValue: '',
        format: 'YYYY-MM-DD HH:mm:ss',
        valueFormat: 'YYYY-MM-DD HH:mm:ss',
        showTime: true,
        placeholder: '请选择下单日期',
      },
      {
        type: 'remoteselect',
        name: 'cxzc_id',
        label: '促销政策',
        disabled: false,
        placeholder: '请选择促销政策',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-policy',
      },
      {
        type: 'remoteselect',
        name: 'shop_id',
        label: '执行门店',
        disabled: !!current_shop,
        placeholder: '请选择执行门店',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-shop',
      },
      {
        type: 'remoteselect',
        name: 'staff_id',
        label: '执行人',
        disabled: false,
        placeholder: '请选择执行人',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-staff',
      },
    ],
    rules: {
      customer_id: [{ required: true, message: '请填输入会员姓名' }],
      date: [{ required: true, message: '请填输入下单日期' }],
      shop_id: [{ required: true, message: '请填输入执行门店' }],
    },
    model: reactive({
      org_id: current_org?.id,
      is_active: true,
      order_code: null,
      project_id: null,
      customer_id: null,
      total_num: null,
      price: null,
      czje: null,
      flje: null,
      zjfl: null,
      zjje: null,
      date: null,
      cxzc_id: null,
      shop_id: current_shop?.id,
      staff_id: null,
    }),
  };
  const edit_model_config_options = {};

  const update_model_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'horizontal',
      col: config.creatCol,
    },
    fields: [],
    rules: {},
    model: reactive({
      org_id: current_org?.id,
      is_active: true,
    }),
  };
  const update_model_config_options = {};

  const titleList = {
    title: '下单',
    addModalTitle: '新建下单',
    updateTitle: '修改下单',
    del_btn: '作废',
    is_create: false, // 是否有【新建】按钮
    is_update: false, // 是否有【修改】按钮
    is_remove: false, // 是否有【删除】按钮
    is_recover: false, // 是否有【恢复】按钮
  };

  const api_fields: Record = {
    update: {
      id: 'id',
    },
    delete: {
      id: 'id',
    },
    recover: {
      id: 'id',
    },
    updateData: {
      org_id: 'org_id',
      id: 'id',
    },
  };

  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_order_record_normal_list,
    addData: create_order_record,
    updateData: None,
    removeData: None,
    recoverData: None,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
